/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */
import { l } from '@atproto/lex-schema';
import * as RepoStrongRef from '../../../com/atproto/repo/strongRef.defs.js';
import * as LabelDefs from '../../../com/atproto/label/defs.defs.js';
import * as MaterialDefs from '../material/defs.defs.js';
const $nsid = 'org.okazu-diary.feed.entry';
export { $nsid };
/** A diary entry to record a self-gratification activity. */
const main = /*#__PURE__*/ l.record('tid', $nsid, 
/*#__PURE__*/ l.object({
    datetime: /*#__PURE__*/ l.string(),
    subjects: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref((() => RepoStrongRef.main)), { maxLength: 16 })),
    tags: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref((() => MaterialDefs.tag)), { maxLength: 64 })),
    note: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ maxLength: 5000, maxGraphemes: 500 })),
    labels: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.typedUnion([
        /*#__PURE__*/ l.typedRef((() => LabelDefs.selfLabels)),
    ], false)),
    lang: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'language' })),
    hadHiatus: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.boolean(), false)),
    visibility: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
    /*#__PURE__*/ l.string(), 'public')),
    via: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref((() => RepoStrongRef.main))),
}));
export { main };
const $type = $nsid;
export { $type };
export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main);
export const $build = /*#__PURE__*/ main.build.bind(main);
export const $assert = /*#__PURE__*/ main.assert.bind(main);
export const $check = /*#__PURE__*/ main.check.bind(main);
export const $cast = /*#__PURE__*/ main.cast.bind(main);
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main);
export const $matches = /*#__PURE__*/ main.matches.bind(main);
export const $parse = /*#__PURE__*/ main.parse.bind(main);
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main);
export const $validate = /*#__PURE__*/ main.validate.bind(main);
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main);
//# sourceMappingURL=entry.defs.js.map